import { useMemo } from 'react';
import { ROUTES } from '../../../../constants/RouteNameMapping';
import { selectedCompanyIdProfileAtom } from '../../state/UIStateJ';
import { companyStateJ } from '../../../../services/state/CompanyStateJ';
import { useAtomValue } from 'jotai';

export function useAllScenariosLocation() {
  const companyId = useAtomValue(selectedCompanyIdProfileAtom);
  const company = useAtomValue(companyStateJ(companyId));
  const path = useMemo(() => {
    if (!company) {
      return '';
    }
    return `/${ROUTES.COMPANY_PROFILES}/${company.name}-${company.id}/${ROUTES.COMPANY_PROFILE_SCENARIOS}`;
  }, [company]);

  return path;
}
